import {createStore, combineReducers, applyMiddleware} from 'redux';
import {createLogger} from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import {composeWithDevTools} from 'redux-devtools-extension';
import user from './user';
import products from './products';
import product from './singleProduct';
import order from './orders';
import productOrder from './productOrders';

const reducer = combineReducers({user, products, product, order, productOrder});
const middleware = composeWithDevTools(
  applyMiddleware(thunkMiddleware, createLogger({collapsed: true}))
);
const store = createStore(reducer, middleware);

export default store;
export * from './user';
export * from './products';
export * from './singleProduct';
export * from './orders';
export * from './orders';
